import cssUtil from 'gw-portals-util-js/CssUtil';
import template from 'text!./LockLogin.html';
import styles from './LockLogin-hashed.scss';
import AuthenticationService from 'plugin?auth-type!gw-portals-auth-js/AuthenticationService';
import ComponentUtil from 'gw-portals-util-js/ComponentUtil';
import appFeatures from 'effective-features!';

// VARS
const hashedTemplate = cssUtil.hashTemplate(template, styles);

// EXPORT

export default {
    template: hashedTemplate,
    controller: [
        '$scope', '$state', 'state_plugin_config', 'oAuth',
        function ($scope, $state, STATE_PLUGIN_CONFIG, oAuth) {
            this.$onInit = function () {
                // VARS
                const authenticationService = AuthenticationService(oAuth);
                const $ctrl = this;
                $ctrl.loginError = '';// errors
                $ctrl.isLoginReqInProgress = false;// animation
                $ctrl.isLoginWithGoogleReqInProgress = false;// animation

                // Default model attr required by gw-pl-inline-ctrl-group directive
                $ctrl.input = {aspects: {}};

                // METHODS
                const setCtrlParam = ComponentUtil.setCtrlParam($ctrl, $scope);

                function setloginError(value) {
                    setCtrlParam('loginError', value);
                }

                $ctrl.loginWithGoogle = function () {
                    setloginError('');// reset errors
                    setCtrlParam('isLoginWithGoogleReqInProgress', true);// animation

                    authenticationService.loginWithGoogle()
                        .then((res) => {
                            setCtrlParam('isLoginWithGoogleReqInProgress', false);// animation
                            return res;
                        })
                        .catch(() => {
                            setCtrlParam('isLoginWithGoogleReqInProgress', false);// animation
                            // something went wrong
                            setloginError('invalidAttempt');
                        });
                };

                $ctrl.login = function () {
                    setloginError('');// reset errors

                    if (!$ctrl.username || !$ctrl.password) { // check if empty
                        setloginError('fieldEmpty');
                        return;
                    }

                    setCtrlParam('isLoginReqInProgress', true);// animation

                    authenticationService.login({
                        username: $ctrl.username,
                        password: $ctrl.password
                    })
                        .then(() => {
                            // logged in
                            setCtrlParam('isLoginReqInProgress', false);// animation
                            // reset errors
                            setloginError('');
                            // redirect user to home view
                            $state.go(STATE_PLUGIN_CONFIG.home);
                        }, (err) => {
                            setCtrlParam('isLoginReqInProgress', false);// animation

                            if (!err || !err.error) {
                                // something went wrong
                                setloginError('invalidAttempt');
                                return;
                            }

                            switch (err.error) {
                                case authenticationService.ERRORS.auth.login_failure: // credentials are wrong
                                case authenticationService.ERRORS.tokens.notLoggedIn: // tokens check problem
                                    setloginError('fieldsIncorrect');
                                    break;
                                case authenticationService.ERRORS.auth.account_locked: { // account is locked
                                    setloginError('accountLocked');
                                    break;
                                }
                                default:
                                    setloginError('invalidAttempt');
                                    break;
                            }
                        });
                };

                $ctrl.forgotPassword = function () {
                    $state.go('authForgotPassword');
                };

                $ctrl.signUp = function () {
                    $state.go('authSignUp');
                };

                $ctrl.isSignUpAllowed = function () {
                    return appFeatures.auth && appFeatures.auth.signUpAllowed;
                };

                $ctrl.forgotPasswordEnabled = function () {
                    return appFeatures.auth && appFeatures.auth.forgotPasswordAllowed;
                };

                $ctrl.socialLoginEnabled = function () {
                    return appFeatures.auth && appFeatures.auth.socialLoginAllowed;
                };
            };
        }]
};